/**
 * <PublicWithNavbar /> — wrapper for public routes (e.g. patent sub-system pages)
 * that should ALSO show the authenticated Navbar when the user is logged in.
 *
 * Behavior:
 *   - Anonymous visitor → render page only (page must handle its own header)
 *   - Authenticated user → render Navbar + page (same chrome as the rest of the app)
 *
 * Why: patent sub-system pages serve two audiences:
 *   1. Marketing — public traffic from HN / Twitter / direct links → no auth needed
 *   2. Paying customers — clicked the Navbar "Inventions" menu → they should keep the Navbar
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import { useAuth } from '../context/AuthContext';
import { SimulationBanner, SimulationProvider } from './SimulationBanner';

const PublicWithNavbar = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Outlet />;
  }

  if (!user) {
    // Anonymous — let the page render fully (it's marketing-first).
    return <Outlet />;
  }

  // Authed — wrap with the same Layout chrome the rest of the app uses.
  return (
    <SimulationProvider>
      <div className="theme-public-light min-h-screen bg-white text-slate-900">
        <SimulationBanner />
        <Navbar />
        <main className="max-w-none">
          <Outlet />
        </main>
      </div>
    </SimulationProvider>
  );
};

export default PublicWithNavbar;
